import AddNewLanguageSelect from './AddNewLanguageSelect'

export default AddNewLanguageSelect
